module.exports = __webpack_public_path__ + "img/noLive.fa15eece.png";